<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'fas fa-tachometer-alt text-dark',
            path: '/dashboard'
          }">
        </sidebar-item>

        <sidebar-item :link="{
                  name: 'Envios',
                  icon: 'fas fa-paper-plane text-dark'
                  }">
          <sidebar-item :link="{ name: 'Nuevo Envío', path: '/envios/nuevo-envio' }"/>
          <sidebar-item :link="{ name: 'Programados', path: '/envios/envios-programados' }"/>
          <sidebar-item :link="{ name: 'Plantillas', path: '/envios/plantillas' }" v-show="menus.drafts" />
          <sidebar-item :link="{ name: 'SMS Link', path: '/envios/sms-link' }" v-show="menus.drafts" />


        </sidebar-item>

        <sidebar-item :link="{
                  name: 'Contactos',
                  icon: 'fas fa-address-book text-dark'
                }">
          <sidebar-item :link="{ name: 'Nueva Lista', path: '/contactos/nueva-lista' }" v-show="menus.contacts_create" />
          <sidebar-item :link="{ name: 'Listas', path: '/contactos/lista-contactos' }" v-show="menus.contacts" />
          <sidebar-item :link="{ name: 'Blacklist', path: '/contactos/blacklist' }" v-show="menus.blacklist" />
        </sidebar-item>

        <sidebar-item :link="{
                        name: 'Reportes',
                        icon: 'ni ni-single-copy-04 text-dark'
                      }">
          <sidebar-item :link="{ name: 'Reporte MT', path: '/reportes/reporte-mt' }" v-show="menus.report" />
          <sidebar-item :link="{ name: 'Reporte MO', path: '/reportes/reporte-mo' }" v-show="menus.report_mo" />
        </sidebar-item>

        <sidebar-item :link="{
                        name: 'Cuenta',
                        icon: 'fas fa-user-circle text-dark'
                      }">
          <sidebar-item :link="{ name: 'Perfil', path: '/cuenta/perfil' }" v-show="menus.my_data" />
          <sidebar-item :link="{ name: 'Nuevo Usuario', path: '/cuenta/nuevo-usuario' }" v-show="menus.users_create" />
          <sidebar-item :link="{ name: 'Usuarios', path: '/cuenta/usuarios' }" v-show="menus.users" />
          <sidebar-item :link="{ name: 'Historial de Compras', path: '/cuenta/historial-compras' }" />
          <sidebar-item :link="{ name: 'Comprar Créditos', path: '/cuenta/comprar-creditos' }" />
        </sidebar-item>

      <!--   <sidebar-item
          :link="{
            name: 'Ayuda',
            icon: 'fas fa-question-circle text-dark',
            path: '/'
          }">
        </sidebar-item> -->



             <modal :show.sync="modals.activation"
                gradient="success"
                modal-classes="modal-danger modal-dialog-centered">
              <h6 slot="header" class="modal-title" id="modal-title-notification">Activar Cuenta</h6>

              <div class="text-center">
                  <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
                  <p class="mb-0">Ingresa tu codigo de Activación</p>
                  <base-input
                            v-model="CodeActivation"
                            class="mb-12 col-md-12"
                            placeholder="1234"
                            prepend-icon="ni ni-world">
                </base-input>
              </div>

              <template slot="footer">
                  <base-button @click="activarCuenta" type="white text-success">
                      Activar
                  </base-button>
              </template>
          </modal>

      </template>


    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';
  import swal from 'sweetalert2';

  import { BasePagination, Modal, Dialog } from '@/components';

  import moment from 'moment';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, onPermissionsUser } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition,
      Modal,
      Dialog
    },
    data() {
      return {
        dataUser: {},
        dataUserActual: getUser(),
        CodeActivation:"",
        modals:{
            activation:false,
        },
        menus: {
          blacklist: onPermissionsUser('blacklist.xhtml', 'view'),
          report: onPermissionsUser('report.xhtml', 'view'),
          contacts: onPermissionsUser('contacts.xhtml', 'view'),
          contacts_create: onPermissionsUser('contacts.xhtml', 'create'),
          drafts: onPermissionsUser('drafts.xhtml', 'view'),
          my_data: onPermissionsUser('my_data.xhtml', 'view'),
          users: onPermissionsUser('users.xhtml', 'view'),
          users_create: onPermissionsUser('users.xhtml', 'create'),
          shippment: onPermissionsUser('shippment.xhtml', 'view'),
          shippment_create: onPermissionsUser('shippment.xhtml', 'create'),
          manual: onPermissionsUser('manual.xhtml', 'view'),
          video: onPermissionsUser('video.xhtml', 'view'),
          report_mo: onPermissionsUser('report_mo.xhtml', 'view'),
          credits_transaction: onPermissionsUser('credits_transaction.xhtml', 'view'),
          credits_transaction_create: onPermissionsUser('credits_transaction.xhtml', 'create')
        }

      }
    },

     watch:{
     'modals.activation'(val){

          if(this.dataUserActual.customer.codeActivation!=this.CodeActivation){
              this.modals.activation=true;
          }

     }

     },
    methods: {


      activarCuenta(){


        this.$loading.show()

          let self = this;
          let user = getUser();


         if(this.dataUserActual.customer.codeActivation==this.CodeActivation){



      this.dataUserActual.customer.codeActivationReceive = this.CodeActivation;

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(this.dataUserActual.customer)),
        "customer_user":encodeURIComponent(JSON.stringify(this.dataUserActual))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_edit, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)
            if (response.data.response == "200") {

              let dataUser = response.data.data;

              dataUser.forEach(function(element) {
                if(element.customerUserId === user.customerUserId) {

                    self.dataUserActual = element;
                    setUser(element);
                }
              })

                self.modals.activation=false;
                swal({
                  title: "Cuenta activada con exito.",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill'
                })

            } else {
              console.log("Error activando cuenta");
              swal({
              title: 'Error activando cuenta',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("Error activando cuenta ",error);
            swal({
              title: 'Error activando cuenta',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
            })

            self.$loading.hide()
        });



          }else{



              swal({
                  title: "Codigo de Activación invalido",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            self.$loading.hide()


              this.modals.activation=true;
          }


      },

      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('scrollbar-inner');
        }
      },

    },
    mounted() {

      this.initScrollbar();
    },
    created(){



      if(this.dataUserActual.customer.codeActivation!=this.dataUserActual.customer.codeActivationReceive){
              this.modals.activation=true;
      }

        var referencia=document.referrer.split("/");
        var actual=document.location.href.split("/");
        if(typeof referencia[2] !== 'undefined' && localStorage.getItem("utm_medium")!=referencia[2] && localStorage.getItem("utm_source")!=referencia[2] && actual[2]!=referencia[2] ){


            if(localStorage.getItem("utm_medium") == "" && localStorage.getItem("utm_medium")!="referencia"){
                localStorage.setItem("utm_medium", "referencia" );
                localStorage.setItem("utm_source", referencia[2] );
            }

        }

         if (  (typeof this.$route.query.utm_source !== "undefined") ){
            localStorage.setItem("utm_source", this.$route.query.utm_source );
        }

         if (  (typeof this.$route.query.utm_medium !== "undefined") ){
            localStorage.setItem("utm_medium", this.$route.query.utm_medium );
        }

         if (  (typeof this.$route.query.utm_campaign !== "undefined") ){
            localStorage.setItem("utm_campaign", this.$route.query.utm_campaign );
        }


    }
  };
</script>
<style lang="scss">
</style>
